import { DataObject } from "../DataObject";
import moment from "moment";

export class RecordCache extends DataObject {
  // projectId optional
  constructor(path) {
    super({
      data: { projectId: "", recordCacheId: "", userId: "" },
      path: path,
      validator: () => {}
    });
  }

  addRecord(record) {
    this._handleRecord(record, true);
  }

  removeRecord(record) {
    this._handleRecord(record, false);
  }

  _handleRecord(record, isAdd) {
    let key = getKey(record);
    let entry = this.data[key];
    if (entry == undefined) entry = { value: 0, count: 0 };

    let value = entry.value + (isAdd ? record.data.value : -record.data.value);
    let count = entry.count + (isAdd ? 1 : -1);

    if (isNaN(count) || count < 0) {
      count = 0;
    }
    if (isNaN(value) || value < 0) {
      value = 0;
    }
    this.data[key] = {
      value,
      count
    };
  }

  getProjectId() {
    return this.data.projectId;
  }
}

function getKey(record) {
  let m = moment(record.data.endTimestamp);
  m.utcOffset(record.data.UTCOffset);
  return m.format("YYYY-MM-DD");
}
